import { useLocationStore } from '@shared/global-store/stores/location/location'

export const localizeUrl = (
  url: string,
  searchParams?: Record<string, string | number | boolean | undefined>
) => {
  const locationStore = useLocationStore()
  const { locale, market } = locationStore.urlPrefix

  const localizedUrl = url.startsWith(`/${locale}-${market}`)
    ? url
    : `/${locale}-${market}${url}`

  if (!searchParams) {
    return addTrailingSlash(localizedUrl)
  }

  const urlSearchParams = new URLSearchParams(
    Object.entries(searchParams).reduce((newSearchParams, [key, value]) => {
      // Remove undefined values
      if (value === null || typeof value === 'undefined') {
        return newSearchParams
      }

      return {
        ...newSearchParams,
        // Convert number and boolean to string
        [key]: String(value),
      }
    }, {})
  )

  return `${addTrailingSlash(localizedUrl)}?${urlSearchParams.toString()}`
}

const addTrailingSlash = (url: string) => {
  if (url.endsWith('/')) {
    return url
  }

  return `${url}/`
}
